module.exports = __webpack_public_path__ + "static/media/wagon-wheel.e78d0cad.png";